var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20402 0.76586L11.3351 2.89695C11.5035 3.06508 11.5984 3.29311 11.5989 3.53106C11.5995 3.76901 11.5057 3.99747 11.3381 4.16638L4.67851 10.876L1.69655 11.5255C1.54927 11.5573 1.39636 11.5517 1.25182 11.5091C1.10727 11.4666 0.975707 11.3885 0.869161 11.2819C0.762616 11.1754 0.684493 11.0438 0.641943 10.8993C0.599392 10.7547 0.593773 10.6018 0.625599 10.4545L1.27505 7.4765L7.92673 0.76586C8.01039 0.681612 8.10988 0.614747 8.21949 0.569119C8.3291 0.523491 8.44665 0.5 8.56538 0.5C8.6841 0.5 8.80165 0.523491 8.91126 0.569119C9.02087 0.614747 9.12036 0.681612 9.20402 0.76586Z",
    fill: "#A5DACB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34139 13.0262C0.93441 13.0262 0.604492 13.3561 0.604492 13.7631C0.604492 14.1701 0.93441 14.5 1.34139 14.5H11.6579C12.0649 14.5 12.3948 14.1701 12.3948 13.7631C12.3948 13.3561 12.0649 13.0262 11.6579 13.0262H1.34139Z",
    fill: "#A5DACB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.cd763dd92308107f36fd360772ccd543.svg";
export { ForwardRef as ReactComponent };